import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { WS_ACTION_TYPES } from '../../redux-saga/actionTypes/index';
import { commands } from '../../constants/index';
import styles from './styles';

const { routesCommand } = commands;

const RoutesButton = ({ t, classes, sendMessageToSocket }) => (
  <React.Fragment>
    <Button
      className={classes.container}
      onClick={() => {
        sendMessageToSocket(routesCommand);
        navigate('routes');
      }}
    >
      <Typography className={classes.route__text}>
        {t('poi-details.label.action-button.routes')}
      </Typography>
    </Button>
  </React.Fragment>
);

RoutesButton.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(RoutesButton)),
);
